import { assoc } from 'ramda';
import { changeUserSettingsSuccess } from '@/routes/user_preferences/actions';
import { authActions } from './actions';

const initialState = {
  /**
   * @type {import('@enmon/commons/lib/enmon').SerializedCustomer | null | undefined}
   */
  customer: undefined,
  /**
   * @type {import('@/services/api/users').GetMePayload | undefined}
   */
  user: undefined,
};

/**
 * @returns {typeof initialState}
 */
function authReducer(state = initialState, action) {
  switch (action.type) {
    case changeUserSettingsSuccess.type:
      return assoc('user', action.payload, state);

    case authActions.loadSession.success.type: {
      const { user, customerData } = action.payload || {};

      return {
        ...state,
        user,
        customer: customerData?.customer ?? null,
      };
    }

    case authActions.logoutFromCustomer.success.type:
      return assoc('customer', null, state);

    case authActions.logout.success.type:
      return {};

    default:
      return state;
  }
}

export default authReducer;
